import { ReactNode } from "react";

import { LogoTheme } from "constants/enum";

export interface LogoProps {
    logoTheme?: LogoTheme;
    logoColorTheme?: LogoColorTheme;
    isTeens?: boolean;
    hasMainLogo?: boolean;
    specialAdditionalLogo?: ReactNode;
    hasAdditionalLogo?: boolean;
    isRelaunch?: boolean;
    isDRS?: boolean;
}

export enum LogoColorTheme {
    TEXT_PRIMARY = "text.primary",
    BASE_PRIMARY = "base.primary",
    BASE_LOGO = "base.logo",
    ACTION_PRIMARY2 = "action.primary2",
}
